  <template lang="pug">
    v-stepper(v-model="e1")
      v-snackbar(
              v-model="snackbar"
              :timeout="10000"
              color='error'
      ) {{ snackbarMessage }}  
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
        v-divider
        v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

      v-stepper-items
        v-stepper-content(step="1")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Judul Pekerjaan
                v-flex(xs7 sm5)
                  v-text-field(id="fik-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Lokasi Pekerjaan
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                          class="inputDefault"
                          label="Lokasi Pekerjaan" 
                          v-model="lokasi" 
                          id="fik-lokasi-kerja"
                          :items="locations.data" 
                          no-data-text="No Data" 
                          color="blue-grey lighten-2" 
                          item-text="location_name" 
                          item-value="data" 
                          clearable
                          chips
                          multiple)
                    v-col
                      v-text-field(id="fik-sub-lokasi" class="inputDefault" v-model='subLokasi' label="Sub Lokasi" counter="100" maxlength="100" height='42')
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Department
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        v-model="deptDivisi"
                        id="fik-dept-divisi"
                        :items="dataUsers.department"
                        label="Department")
                    v-col
                      v-text-field(id="fik-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Tanggal Perizinan
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="startDate"
                        label="mulai dari"
                        prepend-icon="event"
                        id="fik-tgl-izin-start"
                        readonly
                        v-on="on")
                    v-date-picker(id="fik-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="endMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="endDate"
                        label="sampai dengan"
                        prepend-icon="event"
                        id="fik-tgl-izin-end"
                        readonly
                        v-on="on")
                    v-date-picker(id="fik-tgl-picker-end" v-model="endDate" @input="endMenu = false" :min="startDate")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Perusahaan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="perusahaan"
                    id="fik-perusahaan"
                    :items="dataUsers.companies"
                    label="Perusahaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Nama Pemegang Izin
                v-flex(xs7 sm5)
                  v-menu(
                    v-model="searchPemegangMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pemegangIzin.name"
                        label="Pemegang Izin"
                        id="fik-pemegang-izin"
                        readonly
                        v-on="on")
                    PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
                v-flex(xs1 sm4)
          v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="2")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs12 sm12) 
                    h3(class="headerSection") Deskripsi Detail Pekerjaan (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-details-pekerjaan" :editor="editor" v-model="detailPekerjaan" :config="editorConfig")
                    br

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Potensi Bahaya / Risiko Yang Mungkin Ada
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-bahaya" :editor="editor" v-model="bahaya" :config="editorConfig")
                    br
          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="3")
          v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
                v-flex(xs12 sm12) 
                  p(class="headerSection") Daftar Periksa
                v-flex(xs5 sm6)
                  p(class="headerInput") Prosedur kerja (PPO / AKA) ada?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-ppo-aka" class="selectInput" :items='checkOptions' v-model="ppoAka" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Personil telah kompeten bekerja di ketinggian?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-kompeten" class="selectInput" :items='checkOptions' v-model="kompeten" label="Pilih" clearable) 
                
                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah kartu sertifikasi kompetensi kerja di ketinggian masih berlaku?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-kartu-sertifikasi" class="selectInput" :items='checkOptions' v-model="kartuSertifikasiKompetensi" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Area kerja sudah dibarrikade?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-barikade" class="selectInput" :items='checkOptions' v-model="barikade" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Personil tidak phobia di ketinggian?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-phobia" class="selectInput" :items='checkOptions' v-model="phobia" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah personil dalam kondisi fit untuk bekerja dari hasil pemeriksaan kesehatan?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-kondisifit" class="selectInput" :items='checkOptions' v-model="kondisiFit" label="Pilih" clearable) 
                
                v-flex(xs5 sm6)
                  p(class="headerInput") Penguncian / isolasi energi berbahaya dilakukan?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-isolasi" class="selectInput" :items='checkOptions' v-model="isolasi" label="Pilih" clearable) 
                
                v-flex(xs5 sm6)
                  p(class="headerInput") Apa peralatan pelindung jatuh aktif telah diinspeksi? <br/> (safety harness, lanyard, drum tali, tali statis dan titik jangkar).
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-inspeksi-pelindung" class="selectInput" :items='checkOptions' v-model="inspeksiPelindung" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah sistem pelindung jatuh pasif telah terpasang dan diperiksa?<br/> (working elevated platoform, scaffolding dan gondola)
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-jatuh-pasif" class="selectInput" :items='checkOptions' v-model="sistemJatuhPasif" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah rencana penyelamatan dan peralatan telah ditetapkan?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="fik-rencana-penyelamatan" class="selectInput" :items='checkOptions' v-model="rencanaPenyelamatan" label="Pilih" clearable) 

                v-flex(xs5 sm3) 
                  h3(class="headerSection") Upload Dokumen
                v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                  v-file-input(id="fik-document" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                    template(v-slot:selection="{ text }" )
                      v-chip(small label color="primary")   {{ text }}
                v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                  span(id="fik-document") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                  v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                    v-icon mdi-close
                v-flex(xs1 sm4)

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Pengendalian Risiko Tambahan
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-pengendalian-resiko" :editor="editor" v-model="pengendalianRisikoTambahan" :config="editorConfig")
                    br
                
                v-flex(xs12 sm12) 
                    h3(class="headerSection") Catatan Penting Lainnya
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fik-catatan-penting" :editor="editor" v-model="catatanPentingLain" :config="editorConfig")
                    br

          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(class="mr-3" color='info' @click='submit(1)')
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(v-if='!submitClick' color='success' @click='submit(2)')
            v-icon send
            | &nbsp; Submit Request
          v-btn(text @click="backHome()") Cancel
  </template>

  <script>
  import helper from "../helper/index.js";
  import axios from "axios";
  import { mapState } from "vuex";
  import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import PemegangModal from "./PemegangModal.vue";
import { handleError } from "../helper/handleGlobalError.js";
  export default {
    name: "AddKetinggian",
    components: {
      PemegangModal
    },
    props: {
      edit: { type: Boolean, default: false },
      users: Array
    },
    data() {
      return {
        e1: 1,
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [ MyCustomUploadAdapterPlugin ],
          removePlugins : ['ImageUpload','MediaEmbed'],
          toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
          image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
                // This option is equal to a situation where no style is applied.
                'full',
                // This represents an image aligned to the left.
                'alignLeft',
                // This represents an image aligned to the right.
                'alignRight'
            ]
          }
        },
        formCode: 'BIB-HSE-PPO-FRM-036-003',
        todayDate: new Date().toISOString().slice(0,10),
        perusahaan: '',
        judulPekerjaan: '',
        deptDivisi: '',
        divisi: '',
        lokasi: '',
        subLokasi: '',
        pemegangIzin: '',

        searchPemegangMenu: false,
        startDate: null,
        endDate: null,
        startMenu: false,
        endMenu: false,
        startDateExtend: new Date().toISOString().substr(0, 10),
        endDateExtend: new Date().toISOString().substr(0, 10),
        startMenuExtend: false,
        endMenuExtend: false,

        checkOptions: ['Ya', 'Tidak'],
        ppoAka: '',
        kompeten:'',
        kartuSertifikasiKompetensi: '',
        barikade:'',
        phobia: '',
        kondisiFit: '',
        isolasi:'',
        inspeksiPelindung: '',
        sistemJatuhPasif: '',
        rencanaPenyelamatan: '',

        pengendalianRisikoTambahan: '',
        catatanPentingLain: '',
        detailPekerjaan: '',
        bahaya:'',
        snackbarMessage: '',

        uploadId: null,
        docPendukung: null,
        submitClick: false,
        status: 0,
        rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
        ],
        emptyUpload: new File([""], "", {
          type: "",
        })
      };
    },
    mounted: async function() {
      this.$store.dispatch("fetchLocations");
      this.uploadId = Date.now();
    },
    computed: {
      ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
      selectedLoc(){
        let tempLoc = []
        let locationCode;
        
        if(this.dataUsers.location instanceof Array){
          locationCode = this.dataUsers.location[0];
        }else{
          locationCode = this.dataUsers.location;
        }

        for(let i = 0; i < this.lokasi.length; i++){
          tempLoc.push({code: locationCode, name: this.lokasi[i]});
        }
        return tempLoc
      },
      isPage1Complete: function() {
        return !!this.judulPekerjaan && !!this.deptDivisi && !!this.divisi && this.subLokasi && !!this.perusahaan && (this.selectedLoc.length != 0) && !!this.pemegangIzin && !(this.selectedLoc.length<1) && !!this.startDate && !!this.endDate;
      }
    },
    methods: {
      updatePemegangIzin(user) {
        this.pemegangIzin = user;
      },
      clearDate(){
        this.endDate=null;
        this.startMenu = false;
      },
      formatDate:helper.formatDate,
      scrollTop(){
        window.scrollTo(0,0);
      },
      submit(status){
        this.submitClick = true;
        this.status = status;

        let formData = new FormData();
        if (this.edit) {
          formData.append('_id', this.dataEditRequest._id);
          formData.append('ipNo', this.dataEditRequest.ipNo);
          formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
        }
        formData.append('ipStatus', this.status);
        formData.append('ipPerusahaan', this.perusahaan );
        formData.append('ipLocation', JSON.stringify(this.selectedLoc) );
        formData.append('ipSubLokasi', this.subLokasi);
        formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin));
        formData.append('ipJudulPekerjaan', this.judulPekerjaan);
        formData.append('ipDeptDivisi', this.deptDivisi);
        formData.append('ipDivisi', this.divisi);

        formData.append('ipPelaksanaanStart', this.startDate );
        formData.append('ipPelaksanaanEnd', this.endDate );

        formData.append('ipPpoAka', this.ppoAka || 'N/A');
        formData.append('ipKompeten', this.kompeten || 'N/A');
        formData.append('ipKartuSertifikasiKompetensi', this.kartuSertifikasiKompetensi || 'N/A');
        formData.append('ipBarikade', this.barikade || 'N/A');
        formData.append('ipPhobia', this.phobia || 'N/A');
        formData.append('ipKondisiFit', this.kondisiFit || 'N/A');
        formData.append('ipIsolasi', this.isolasi || 'N/A');
        formData.append('ipInspeksiPelindung', this.inspeksiPelindung || 'N/A');
        formData.append('ipSistemJatuhPasif', this.sistemJatuhPasif || 'N/A');
        formData.append('ipRencanaPenyelamatan', this.rencanaPenyelamatan || 'N/A');
        
        formData.append('ipPengendalianRisikoTambahan', this.pengendalianRisikoTambahan);
        formData.append('ipCatatanPentingLain', this.catatanPentingLain);
        formData.append('ipDetailPekerjaan', this.detailPekerjaan);
        formData.append('ipBahaya',this.bahaya);

        formData.append('uploadId', this.uploadId );
        formData.append('ipUser', JSON.stringify(this.dataUsers) );
        formData.append('ipForm', this.formCode);

        const config = {
          method: this.edit ? "put" : "post",
          url: `${this.API_URL}/v1/requests`,
          headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
        };
        axios(config).then(res => {
          this.$store.commit("temporaryData", res);
          this.$router.push("/my-permit");
        }).catch(error => {
          handleError(error, {
            setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
            showSnackbar: (show) => { this.snackbar = show; },
            disableLoader: () => {
              this.$store.state.loader = false;
            },
          });
          this.submitClick = false;
        });
      },
      // upload(name, paramFile){
      //   if(paramFile == undefined) return ;
      //   if(paramFile.size > 10000000){
      //     paramFile = null;
      //     if(name == 'docPendukung'){
      //       this.docPendukung = this.emptyUpload;
      //     }
      //     return
      //   }else{
      //     let formData = new FormData();
      //     formData.append('uploadId', this.uploadId );
      //     formData.append(name, paramFile );
      //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      //   }      
      // },
      deleteDocPendukung(name){
        let id = this.uploadId.toString();      
        this.$store
          .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
          })
          .then(() => {
            this.docPendukung = null;
          })
          .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
      },
      backHome(){
        this.$router.push("/my-permit");
      },
      backStep(){
        this.e1--
      },
      docName(name){
        return this.$setFilename(name);
      }
    },
    watch: {
      docPendukung(params){
        if(params && params.size < 10000000){
          let formData = new FormData();
          formData.append('uploadId', this.uploadId );
          formData.append('docPendukung', params );
          axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
        }
    },
      dataEditRequest: async function() {
        this.perusahaan = this.dataEditRequest.ipPerusahaan;
        // for (const item of this.locations) {
        //   let checked = false
        //   for (const element of this.dataEditRequest.ipLocation) {
        //     if(item.name == element.name) checked = true
        //   } 
        //   if(checked) this.lokasi.push(true)
        //   else this.lokasi.push(false)
        // }
        this.lokasi = [];
        for(const loc of this.dataEditRequest.ipLocation) {
          this.lokasi.push(loc.name);
        }
        this.subLokasi = this.dataEditRequest.ipSubLokasi;
        this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
        this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0,10);
        this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0,10);
        this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
        this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
        this.divisi = this.dataEditRequest.ipDivisi;

        this.ppoAka = this.dataEditRequest.ipPpoAka;
        this.kompeten = this.dataEditRequest.ipKompeten;
        this.kartuSertifikasiKompetensi = this.dataEditRequest.ipKartuSertifikasiKompetensi;
        this.barikade = this.dataEditRequest.ipBarikade;
        this.phobia = this.dataEditRequest.ipPhobia;
        this.kondisiFit = this.dataEditRequest.ipKondisiFit;
        this.isolasi = this.dataEditRequest.ipIsolasi;
        this.inspeksiPelindung = this.dataEditRequest.ipInspeksiPelindung;
        this.sistemJatuhPasif = this.dataEditRequest.ipSistemJatuhPasif;
        this.rencanaPenyelamatan = this.dataEditRequest.ipRencanaPenyelamatan;

        this.pengendalianRisikoTambahan = this.dataEditRequest.ipPengendalianRisikoTambahan;
        this.catatanPentingLain = this.dataEditRequest.ipCatatanPentingLain;
        this.detailPekerjaan = this.dataEditRequest.ipDetailPekerjaan;
        this.bahaya = this.dataEditRequest.ipBahaya;

        this.uploadId = this.dataEditRequest.uploadId;
        this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
      },
    }
  };
  </script>

  <style>
  .ck-editor__editable {
      min-height: 300px;
      max-height: 300px;
      resize:none;
  }
  .mustFill {
    color: #EA5164;
  }
  </style>
